import { render, staticRenderFns } from "./ReportFindingsFormLevelOne.vue?vue&type=template&id=1213dcd1&scoped=true&"
import script from "./ReportFindingsFormLevelOne.vue?vue&type=script&lang=js&"
export * from "./ReportFindingsFormLevelOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1213dcd1",
  null
  
)

export default component.exports